import styled, { css } from 'styled-components';
import { RichTextCssTextStyles } from './RichTextCssTextStyles.ts';
import { StyledRteTheme } from './StyledRteTheme.tsx';

export const StyledRteEditor = styled.div<{
  minHeight: number;
  maxHeight?: number;
}>`
  /* .ant-input-affix-wrapper, */
  /* &.rte-input-editor-wrapper { */
  position: relative;
  display: block;
  width: 100%;
  width: auto;
  min-width: 0;
  padding: 4px 11px;
  font-size: ${props => props.theme.fontSize ?? StyledRteTheme.fontSize}px;
  line-height: ${props => props.theme.lineHeight ?? StyledRteTheme.lineHeight};
  background-color: ${props =>
    props.theme.colorBgContainer ?? StyledRteTheme.colorBgContainer};
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: ${props =>
    props.theme.colorBorder ?? StyledRteTheme.colorBorder};
  border-radius: ${props =>
    props.theme.borderRadius ?? StyledRteTheme.borderRadius}px;
  transition: all 0.2s;

  max-height: calc(100vh - 120px);
  overflow-y: auto;

  ${props =>
    props.maxHeight &&
    css`
      max-height: ${props.maxHeight}px;
    `}

  &.rte-input-has-menu-bar {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  /* &.ant-input-affix-wrapper-lg, */
  &.rte-input-lg {
    padding: 7px 11px;
    min-height: 40px;
    font-size: ${props =>
      props.theme.fontSizeLG ?? StyledRteTheme.fontSizeLG}px;
    line-height: 1.5;
    border-radius: ${props =>
      props.theme.borderRadiusLG ?? StyledRteTheme.borderRadiusLG}px;
    &.rte-input-has-menu-bar {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
  /* &.input-affix-wrapper-sm, */
  &.rte-input-sm {
    padding: 0 7px;
    border-radius: ${props =>
      props.theme.borderRadiusSM ?? StyledRteTheme.borderRadiusSM}px;
    &.rte-input-has-menu-bar {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }
  &:hover,
  &:focus,
  &:focus-visible {
    border-inline-end-width: 1px;
    z-index: 1;
  }

  // Errori
  .ant-form-item-has-error & {
    border-color: ${props =>
      props.theme.colorError ?? StyledRteTheme.colorError};
  }

  // Disabilitato
  /* &.ant-input-affix-wrapper-disabled, */
  &.rte-input-disabled {
    color: ${props =>
      props.theme.colorTextDisabled ?? StyledRteTheme.colorTextDisabled};
    background-color: ${props =>
      props.theme.colorBgContainerDisabled ??
      StyledRteTheme.colorBgContainerDisabled};
    border-color: ${props =>
      props.theme.colorBorder ?? StyledRteTheme.colorBorder};
    box-shadow: 'none';
    cursor: not-allowed;
  }
  /* } */
  // Stili per l'editor (campo di input)
  .ProseMirror,
  .rich-text-input-editor {
    overflow: hidden;
    white-space: pre-wrap;

    &:focus,
    &:focus-visible {
      outline: none;
    }
  }
  // Altezza dell'editor (campo di input)
  .ProseMirror,
  .rich-text-input-editor {
    min-height: ${props => props.minHeight}px;
  }
  // Stili per il testo contenuto dell'editor
  .ProseMirror {
    line-height: 1.2;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-top: 0;
      margin-bottom: ${props =>
        props.theme.rteHtmlTagMarginBottom ??
        StyledRteTheme.rteHtmlTagMarginBottom}em;
      font-weight: 600;
    }
    p,
    a,
    ol,
    ul,
    dl {
      margin-top: 0;
      margin-bottom: ${props =>
        props.theme.rteHtmlTagMarginBottom ??
        StyledRteTheme.rteHtmlTagMarginBottom}em;
      p {
        margin-bottom: 0;
      }
    }
    a {
      text-decoration: underline;
      color: ${props => props.theme.colorLink ?? StyledRteTheme.colorLink};
      &:hover,
      &:focus,
      &:focus-visible {
        color: ${props =>
          props.theme.colorLinkHover ?? StyledRteTheme.colorLinkHover};
      }
      &:active {
        color: ${props =>
          props.theme.colorLinkActive ?? StyledRteTheme.colorLinkActive};
      }
    }

    ol ol,
    ul ul,
    ol ul,
    ul ol {
      margin-bottom: 0;
    }

    b,
    strong {
      font-weight: 700;
    }
    pre {
      margin-top: 0;
      margin-bottom: ${props =>
        props.theme.rteHtmlTagMarginBottom ??
        StyledRteTheme.rteHtmlTagMarginBottom}em;
      overflow: auto;
      white-space: normal;
    }
    .survey-color {
      color: ${props =>
        (props.theme as any).engine?.accentColor ??
        StyledRteTheme.defaultAccentColor};
    }
    .survey-background-color {
      background-color: ${props =>
        // Il vero problema qui è che in `form` giustamente `engine` non esiste.
        // Andrebbe spostato lo stile in web.
        (props.theme as any).engine?.accentColor ??
        StyledRteTheme.defaultAccentColor};
    }
    ${RichTextCssTextStyles}

    [data-omissis='true'] {
      background-color: rgba(0, 0, 0, 0.06);
      border-bottom: 1px dashed currentColor;
      padding: 0 5px;
    }
  }
`;
